export default class CashOrder {
  static create() {
    return {
      // @ToDo: Fix currency id, get by company and etc..................
      currency_id: 1,

      comment: null,
      sum: null,
      cash_order_basis_id: null,
      cash_order_operation_id: null,
      company_id: null,
      employer_id: null,
      sender_id: null,
      recipient_id: null,
      sender_type: null,
      recipient_type: null,
      basis: {},
      employer: {},
      operation: {
        params: {
          recipient: {},
          sender: {},
        },
      },
      recipient: {},
      sender: {},
    }
  }
}
